import { connect } from 'react-redux';
import { getSelected } from '../utils/seatMapContentContainerUtils';
import BookableSeat from '../components/rowsandcolums/BookableSeat';
import { getNameInitials } from '../utils/getNameInitials';
const selected = function (seat, selectedSeats) {
  if (selectedSeats === void 0) {
    selectedSeats = [];
  }
  return selectedSeats.some(s => s.value === seat);
};
const selectedTraveler = function (seat, selectedSeats) {
  if (selectedSeats === void 0) {
    selectedSeats = [];
  }
  return selectedSeats.find(s => s.value === seat);
};
export const mapStateToProps = (state, _ref) => {
  var _selectedTraveler;
  let {
    activeSegment,
    form,
    isRyanairInTrip,
    seat
  } = _ref;
  const selectedSeats = Object.values(getSelected('seatMap', form)(state)(activeSegment));
  const isSelected = selected(seat, selectedSeats);
  const selectedTravelerName = isSelected ? (_selectedTraveler = selectedTraveler(seat, selectedSeats)) === null || _selectedTraveler === void 0 ? void 0 : _selectedTraveler.name : null;
  const selectedSeatInitials = selectedTravelerName ? getNameInitials(selectedTravelerName) : null;
  return {
    isRyanairInTrip,
    isSelected,
    selectedSeatInitials
  };
};
export default connect(mapStateToProps)(BookableSeat);
//# sourceMappingURL=BookableSeatContainer.js.map